<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Registration Pending</div>
                    <div class="card-body">
                        You will receive an email with confirmation of your login details within 2 working days
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>